export default "__VITE_ASSET__M9ORcRZG__"